import React from 'react';
import Typography from '@mui/material/Typography';

import styles from 'src/components/errors/ErrorPage.module.css';

type Props = {
    image: string;
    title: string;
    message: React.ReactNode;
    /** Fill the viewport (standalone route) instead of the parent container. */
    fullPage?: boolean;
    children?: React.ReactNode;
};

export const SUPPORT_EMAIL = 'support@reffie.me';

export function SupportLink() {
    return <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>;
}

export default function ErrorPage({ image, title, message, fullPage, children }: Props) {
    return (
        <div className={`${styles.page} ${fullPage ? styles.fullPage : ''}`} role="alert">
            <img className={styles.image} src={image} alt="" />
            <Typography variant="h3" color="primary">{title}</Typography>
            <Typography variant="body1" color="text.secondary" className={styles.message}>{message}</Typography>
            {children}
        </div>
    );
}
